import { ActionReducerMap } from '@ngrx/store';
import { locationReducer, LocationsState } from './features/location-store';

export interface RootState {
  locations: LocationsState;
}

export const rootReducers: ActionReducerMap<RootState> = {
  locations: locationReducer,
};
